class AccountsListController implements ng.IComponentController {

    private menu: string;
    private sortType: string;

    constructor() {
        'ngInject';
        // console.log('AccountsListController');
    }

    public $onInit = () => {
        this.sortType = 'name';
        this.menu = 'list';
    }
}

export const accountsListComponent = {
    bindings: {
        accounts: '<'
    },
    controller: AccountsListController,
    template: require('./accounts.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/accounts/accounts.list.component.ts